import { IntlShape } from "react-intl";
import getLabel from "helpers/getLabel";

const trackingReferenceOption = (intl: IntlShape) => [
  {
    label: intl.formatMessage({
      id: "tracking.pleaseSelect",
      defaultMessage: "Please select",
    }),
    value: "",
  },
  {
    label: intl.formatMessage(
      {
        id: "general.trackingNumber",
        defaultMessage: "Tracking number",
      },
      {
        shipmentTitle: getLabel("Tracking number", "capitalize-first"),
      },
    ),
    value: "primary",
  },
  {
    label: intl.formatMessage({
      id: "tableHeaders.MAWBNumber",
      defaultMessage: "MAWB number",
    }),
    value: "mawb",
  },
  {
    label: intl.formatMessage({
      id: "tracking.referenceOptionContainerNumber",
      defaultMessage: "Container number",
    }),
    value: "container_no",
  },
  {
    label: intl.formatMessage({
      id: "tracking.referenceOptionTruckNumber",
      defaultMessage: "Truck number",
    }),
    value: "truck",
  },
];

export default trackingReferenceOption;
